import { render, staticRenderFns } from "./EstatePlanningSurvey.vue?vue&type=template&id=02cdc9a9"
import script from "./EstatePlanningSurvey.vue?vue&type=script&lang=js"
export * from "./EstatePlanningSurvey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports